import { render } from "./DrawerMainArea.vue?vue&type=template&id=5c490cb8&scoped=true"
import script from "./DrawerMainArea.vue?vue&type=script&lang=js"
export * from "./DrawerMainArea.vue?vue&type=script&lang=js"

import "./DrawerMainArea.vue?vue&type=style&index=0&id=5c490cb8&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c490cb8"]])

export default __exports__